import { Box, ChakraProvider } from '@chakra-ui/react';

import { ApolloProvider } from '@apollo/client';
import FooterContainer from '../footer/footer-container';
import { NavBar } from '../navigation/NavBar';
import React from 'react';
import { client } from '../../../lib/apolloClient';
import theme from '../../theme/theme';

const Layout = ({ children }: LayoutProps) => {
    return (
        <ApolloProvider client={client}>
            <ChakraProvider theme={theme}>
                <NavBar></NavBar>
                <Box as="main">{children}</Box>
                <FooterContainer></FooterContainer>
            </ChakraProvider>
        </ApolloProvider>
    );
};

type LayoutProps = {
    children: React.ReactNode;
};

export default Layout;
